<template>
  <div>

    <loading :loading="loading"></loading>

    <error-alert-item
        :error-alert-event="errorAlertEvent"
        :network-error="networkError"
        @resetErrorAlertEvent="errorAlertEvent=false"
    ></error-alert-item>

    <refresh-item
        :show="showRefreshItem"
        @onRefresh="fetchCreditAssessmentSummaryAndReportUrl"
    ></refresh-item>

    <div v-show="showUI">
      <weex-text
          v-if="heading"
          class="item-sm-heading border-bottom margin-top-20"
          v-html="heading"
      ></weex-text>

      <div
          v-if="bureauBandMessage"
          class="padding-10 margin-left-5 margin-right-5 margin-top-20 border-without-color"
          :style="getBureauBandMessageBackgroundStyle">

        <weex-text class="font-size-base" :style="getBureauBandMessageTextStyle">
          {{ bureauBandMessage }}
        </weex-text>

      </div>

      <credit-assessment-log-summary-item
          class="margin-top-20"
          :credit-assessment-logs="creditAssessmentLogs"
      ></credit-assessment-log-summary-item>

      <wxc-button
          text="Next"
          class="margin-top-30 margin-bottom-20 horizontal-center"
          type="blue"
          @wxcButtonClicked="onNextClicked"
      ></wxc-button>

    </div>

  </div>
</template>

<script>

import { Constants } from "@/components/Constants";
import WxcButton from "../../../weex-ui/packages/wxc-button/index";
import Loading from "@/components/layout/Loading";
import ErrorAlertItem from "@/components/layout/ErrorAlertItem";
import RefreshItem from "@/components/layout/RefreshItem";
import DataSource from "@/data/DataSource";
import { DataTables } from "@/utils/DataTables";
import LoanScopeDataHolder from "@/data/model/LoanScopeDataHolder";
import CreditAssessmentLogSummaryItem from "@/components/layout/CreditAssessmentLogSummaryItem";

export default {
  name: "CreditAssessmentLogsItem",
  components: {
    WxcButton,
    Loading,
    ErrorAlertItem,
    RefreshItem,
    CreditAssessmentLogSummaryItem
  },
  data: () => ({
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showRefreshItem: false,
    showUI: false,

    creditAssessmentLogs: [],
    bureauType: "", //type in credit_assessment_log\
    bureauReportName: "", //pdf document name (report pdf)
    bureauBand: "", //top message color coding in bureau details
    bureauBandMessage: "", //top message in bureau details
    heading: ""
  }),
  props: {},

  methods: {
    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    showCreditAssessmentLogsExternal(
        heading, bureauType, bureauBand, bureauBandMessage, bureauReportName
    ) {
      this.heading = heading;
      this.bureauType = bureauType;
      this.bureauBand = bureauBand;
      this.bureauBandMessage = bureauBandMessage;
      this.bureauReportName = bureauReportName;

      this.fetchCreditAssessmentSummaryAndReportUrl();
    },

    fetchCreditAssessmentSummaryAndReportUrl() {
      //todo fetch report url
      this.showRefreshItem = false;
      if (this.bureauType) {
        this.loading = true;
        DataSource.getDataOfDataTableInfoWithFilter(
            DataTables.CREDIT_ASSESSMENT_LOG,
            LoanScopeDataHolder.getLoanId(),
            "type",
            this.bureauType
        )
        .then(creditAssessmentLogRes => {
          this.loading = false;
          if (creditAssessmentLogRes.errorOccurred) {
            this.showError(creditAssessmentLogRes.data);
            this.showRefreshItem = true;
          } else {
            this.showUI = true;
            this.creditAssessmentLogs = creditAssessmentLogRes.data;
          }
        })
      }
    },

    onNextClicked() {
      this.$emit("onNextClicked");
    },
  },

  computed: {
    getBureauBandMessageBackgroundStyle() {
      const backgroundStyle = {};

      const bureauBandDetails = Constants.getBureauBandDetails(this.bureauBand);
      if (bureauBandDetails) {
        backgroundStyle["background-color"] = bureauBandDetails.backgroundColor;
        backgroundStyle["border-color"] = bureauBandDetails.borderColor;
      }

      return backgroundStyle;
    },

    getBureauBandMessageTextStyle() {
      const textStyle = {};

      const bureauBandDetails = Constants.getBureauBandDetails(this.bureauBand);
      if (bureauBandDetails) {
        textStyle["color"] = bureauBandDetails.textColor;
      }

      return textStyle;
    },
  }
};
</script>

<style
    scoped
    src="../../assets/style/base.css"></style>

